module.exports = __webpack_public_path__ + "img/settings.8e3ee5a5.svg";